
import fusion from "@/api/fusion";
import { set, get } from "@/utils/vuex";
import { Bridge } from '@k4connect/capacitor-plugin'
import axios from "axios";
import env from "@/api/env";
import _ from 'lodash';
import Bugsnag from '@bugsnag/js'
import { strings } from "@/plugins/strings";

const state = () => ({
	loaded: false,
	nativeEnabled: false,
	token: null,
	userInformation: null,
	connectors: [],
	availableConnectors: [],
	types: [],
	showPairing: false,
	error: null
});


const getters = {


	getConnector(state)
	{
		return (id) => {
			return _.find(state.connectors, [ 'id', id]);
		}
	},
	getType(state)
	{
		return (id) => {
			return _.find(state.types, [ 'id', id ]);
		}
	},
	showSetup(state)
	{
		if(!state.loaded) return false;
		if(!state.userInformation) return true;

		const { weight, height, birthdate, gender } = state.userInformation;
		if(!weight || !height || !birthdate || !gender ) return true;
	},
	isEmpty(state, getters)
	{
		return getters.showSetup || (state.userInformation && state.userInformation.connectedSources.length == 0);
	},
	connectedSources(state)
	{
		const { userInformation } = state;
		if(!userInformation || userInformation.connectedSources.length == 0)
		{
			return [];
		}

		_.each(userInformation.connectedSources, (source)=> {
			source.device = _.find(state.connectors, ['id', source.dataSource ]);
		});

		return userInformation.connectedSources;
	},

	isLoaded: get('loaded'),
	error: get('error')

};

const mutations = {
	
	setNativeEnabled: set('nativeEnabled'),
	setToken: set('token'),
	setUserInformation: set('userInformation'),
	setConnectors: set('connectors'),
	setAvailableConnectors: set('availableConnectors'),
	setTypes: set('types'),
	setLoaded: set('loaded'),
	setError: set('error'),
	setShowPairing: set('showPairing'),
};

const actions = {

	load: async ({commit, rootGetters, dispatch}) => {

		commit('setError', null);
		
		const wellnessEnabled = rootGetters['flags/flag']('wellnessEnabled');
		if(!wellnessEnabled) return;

		const { data } = await axios.get(env.thryve());
		commit('setConnectors', data.connectors);	
		commit('setTypes', data.types);	
		
		try {
			const jwt = await fusion.login();
			

			if(rootGetters['mobile/isK4App'])
			{
				//native login
				const credentials = await fusion.wellnessLogin();	
				let response = await Bridge.thryveInit({ ...credentials, language: 'en'})
				const token = (response instanceof Map) ? response.get('token') : response.token;
				commit('setToken', token);
				
				response = await Bridge.thryveIsNativeActive();
				const active = (response instanceof Map) ? response.get('active') : response.active;
				commit('setNativeEnabled', active === 'true');

			} else {
				//web login
				
				const response = await Bridge.thryveLogin({ jwt, apiUrl: env.wellness() });
				const token = (response instanceof Map) ? response.get('token') : response.token;
				commit('setToken', token);
			}

			await dispatch('getUserInformation');
			
			commit('setLoaded', true);
		} catch(e) {
			Bugsnag.notify(e);
			commit('setError', strings.wellness.loginError)
		}

		
	},

	resume: async ({state, dispatch}) => {
		if(state.token)
		{
			dispatch('getUserInformation');
		} else {
			dispatch('load');
		}
	},

	

	uploadUserInformation: async ({commit, state}, { height, weight, birthdate, gender }) => {
		
		const info = { height, weight, birthdate, gender };
		await Bridge.thryveUploadUserInformation(info);

		const connectedSources = (state.userInformation) ? state.userInformation.connectedSources : [];

		commit('setUserInformation', { ...info, connectedSources });

	},

	getUserInformation: async ({commit, state, rootGetters}) => {

		const wellnessEnabled = rootGetters['flags/flag']('wellnessEnabled');
		if(!wellnessEnabled) return;
		
		const response = await Bridge.thryveGetUserInformation();
		const info = (response instanceof Map) ? Object.fromEntries(response) : response;
		info.connectedSources = info.connectedSources || [];


		const isK4App = rootGetters['mobile/isK4App'];
		const isIos = rootGetters['mobile/isIos'];
		const isAndroid = rootGetters['mobile/isAndroid'];

		const available =  _.filter(state.connectors, (connector) => {
			if(isK4App)
			{
				if(!connector.native) return true;
				if(isIos && connector.platform == 'ios') return true;
				if(isAndroid && connector.platform == 'android') return true;
			} else {
				if(!connector.native) return true;
			}
			return false;
		});

		_.each(available, (connector) => {
			connector.enabled = !!_.find(info.connectedSources, [ 'dataSource', connector.id ]);
		})

		commit('setAvailableConnectors', available);

		commit('setUserInformation', info);
		return info;
	},

	getConnectDataSourceUrl: async (ctx, { dataSourceId, redirectString = null }) => {
		const response = await Bridge.thryveGetConnectDataSourceUrl({ dataSourceId, redirectString });
		return (response instanceof Map) ? response.get('url') : response.url;
	},

	getRevokeDataSourceUrl: async (ctx, { dataSourceId, redirectString = null, requireUserAction = false }) => {
		const response = await Bridge.thryveGetRevokeDataSourceUrl({ dataSourceId, redirectString, requireUserAction });
		return (response instanceof Map) ? response.get('url') : response.url;
	},

	nativeActive: async () => {
		const response = await Bridge.thryveIsNativeActive();
		const active = (response instanceof Map) ? response.get('active') : response.active;
		return active == 'true';
		
	},

	nativeStart: async () => {
		await Bridge.thryveNativeStart();
	},

	nativeStop: async () => {
		await Bridge.thryveNativeStop();
	},

	getUserValue: async ({state}, { startTimestamp, endTimestamp }) => {
		return await fusion.wellnessUserValue(state.token, startTimestamp, endTimestamp);
	},

	uploadUserValue: async ({state}, data) => {
		return await fusion.wellnessUploadUserValue(state.token, { data });
	},

	getUserDailyValue: async ({state}, { startDay, endDay }) => {
		return await fusion.wellnessUserDailyValue(state.token, startDay, endDay);
	},

	uploadUserDailyValue: async ({state}, { date, type, value }) => {
		return await fusion.wellnessUploadUserDailyValue(state.token, { date, type, value });
	},

	showPairing: async ({commit}, value) => {
		commit('setShowPairing', value);
	},




};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};